import { isEmpty } from "lodash";
import localstorage from "../../../plugins/localstorage";
import { app } from "../../../config";
import * as services from "../services";
import { getError } from "@/app/plugins/utils";
import { getMarketplaces } from "@/app/domains/Records/services";
import { decrypt } from "../../../plugins/utils/crypto";
export const attemptUpdatePassword = (form) => {
  try {
    let promise = new Promise((resolve, reject) => {
      services
        .forgotPassword(form)
        .then((response) => {
          resolve(response); // keep promise chain
        })
        .catch((error) => {
          reject(getError(error));
        });
    });
    return promise;
  } catch (err) {
    console.log(err);
  }
};

export const attemptChangePassword = (form) => {
  try {
    let promise = new Promise((resolve, reject) => {
      services
        .changePassword(form)
        .then((response) => {
          resolve(response); // keep promise chain
        })
        .catch((error) => {
          reject(getError(error));
        });
    });
    return promise;
  } catch (err) {
    console.log(err);
  }
};

export const attemptLogin = ({ commit }, payload) => {
  try {
    let promise = new Promise((resolve, reject) => {
      services
        .postLogin(payload)
        .then((response) => {
          commit("SET_TOKEN", response.meta.token);
          commit("SET_SURVEY", response.meta.survey);
          commit("SET_USER", response.data);
          if (!response.data.current_account) {
            console.log("erro login");
          } else {
            commit("SET_USER", response.data);
          }
          resolve(response.data);
        })
        .catch((error) => {
          reject(getError(error));
          // reject(error)
        });
    });
    return promise;
  } catch (err) {
    console.log(err);
  }
};

export const attemptLogout = ({ dispatch }) => {
  services.logout().then(() => {
    dispatch("setToken", null);
    // dispatch('cleanUser')
    // commit('CLEAN_USER')
    dispatch("LOGOUT");
  });
};

export const setUser = ({ commit }, user) => {
  // Commit the mutations
  commit("SET_USER", user);

  Promise.resolve(user); // keep promise chain
};

export const setToken = ({ commit }, payload) => {

  // prevent if payload is a object
  const token = isEmpty(payload) ? null : payload.token || payload;

  // Commit the mutations
  commit("SET_TOKEN", token);

  return Promise.resolve(token); // keep promise chain
};

export const setGSK = ({ commit }, payload) => {
  commit("SET_GSK", payload);
  return Promise.resolve(payload);
};

export const checkUserToken = ({ dispatch, state }) => {
  // If the token exists then all validation has already been done
  if (!isEmpty(state.token)) {
    return Promise.resolve(state.token);
  }
  /**
   * Token does not exist yet
   * - Recover it from localstorage
   * - Recover also the user, validating the token also
   */
  return (
    localstorage
      .getItem(app.userTokenStorageKey)
      .then((token) => {
        if (isEmpty(token)) {
          // Token is not saved in localstorage
          return Promise.reject(new Error("NO_TOKEN")); // Reject promise
        }
        // Put the token in the vuex store
        return dispatch("setToken", token); // keep promise chain
      })
      // With the token in hand, retrieves the user's data, validating the token
      .then(() => dispatch("loadUser"))
  );
};

/**
 * Retrieves updated user information
 * If something goes wrong, the user's token is probably invalid
 */
export const loadUser = ({ dispatch, commit }) =>
  services
    .loadUserData()
    .then(async (response) => {
      if (response.data == undefined) {
        let dataDecryp = decrypt(response.replace("ENCRYPTED:", "").trim());
        
        let jsonDecrypt = JSON.parse(dataDecryp);
        

        let profilePermissions = [];
        let productPermissions = [];

        if (jsonDecrypt.data.profile && jsonDecrypt.data.profile.permissions) {
          profilePermissions = jsonDecrypt.data.profile.permissions.map(
            (p) => p.key
          );
        }

        if (jsonDecrypt.data.products != undefined && jsonDecrypt.data.products.length > 0) {
          productPermissions = jsonDecrypt.data.products.map((p) => p.key);
        }

        let permissions = [
          ...profilePermissions,
          ...productPermissions,
          jsonDecrypt.data.type_account_id.toString(),
        ];

        commit("SET_CURRENT_PERMISSION", permissions);

        if (jsonDecrypt.data.agent_id) {
          commit("SET_COLOR_THEME", {
            colorPrimary: jsonDecrypt.data.agent.marketplace.color_primary,
            colorSecondary: jsonDecrypt.data.agent.marketplace.color_secondary,
          });
        } else if (jsonDecrypt.data.department_store_id) {
          commit("SET_COLOR_THEME", {
            colorPrimary:
              jsonDecrypt.data.department_store.marketplace.color_primary,
            colorSecondary:
              jsonDecrypt.data.department_store.marketplace.color_secondary,
          });
        } else if (jsonDecrypt.data.marketplace_id) {
          if (jsonDecrypt.data.marketplace.color_primary === null) {
            commit("SET_COLOR_THEME", {
              colorPrimary: "#001730",
              colorSecondary: "#fd1d18",
            });
          } else {
            commit("SET_COLOR_THEME", {
              colorPrimary: jsonDecrypt.data.marketplace.color_primary,
              colorSecondary: jsonDecrypt.data.marketplace.color_secondary,
            });
          }
        } else if (jsonDecrypt.data.type_account_id === 6) {
          commit("SET_COLOR_THEME", {
            colorPrimary:
              jsonDecrypt.data.marketplace_manager.color_primary == null
                ? "#001730"
                : jsonDecrypt.data.marketplace_manager.color_primary,
            colorSecondary:
              jsonDecrypt.data.marketplace_manager.color_secondary == null
                ? "#fd1d18"
                : jsonDecrypt.data.marketplace_manager.color_secondary,
          });
        } else {
          commit("SET_COLOR_THEME", {
            colorPrimary: "#001730",
            colorSecondary: "#fd1d18",
          });
        }
        // Tipo de conta (1 = Admin | 2 = Marketplace | 4 = Representante | 5 = Estabelecimento Comercial)
        commit("SET_USER", jsonDecrypt.data);
        return jsonDecrypt.data;
      } else {
        let profilePermissions = [];

        if (response.data.profile && response.data.profile.permissions) {
          profilePermissions = response.data.profile.permissions.map(
            (p) => p.key
          );
        }

        let permissions = [
          ...profilePermissions,
          response.data.type_account_id.toString(),
        ];

        commit("SET_CURRENT_PERMISSION", permissions);

        if (response.data.agent_id) {
          commit("SET_COLOR_THEME", {
            colorPrimary: response.data.agent.marketplace.color_primary,
            colorSecondary: response.data.agent.marketplace.color_secondary,
          });
        } else if (response.data.department_store_id) {
          commit("SET_COLOR_THEME", {
            colorPrimary:
              response.data.department_store.marketplace.color_primary,
            colorSecondary:
              response.data.department_store.marketplace.color_secondary,
          });
        } else if (response.data.marketplace_id) {
          if (response.data.marketplace.color_primary === null) {
            commit("SET_COLOR_THEME", {
              colorPrimary: "#001730",
              colorSecondary: "#fd1d18",
            });
          } else {
            commit("SET_COLOR_THEME", {
              colorPrimary: response.data.marketplace.color_primary,
              colorSecondary: response.data.marketplace.color_secondary,
            });
          }
        } else if (response.data.type_account_id === 6) {
          commit("SET_COLOR_THEME", {
            colorPrimary:
              response.data.marketplace_manager.color_primary == null
                ? "#001730"
                : response.data.marketplace_manager.color_primary,
            colorSecondary:
              response.data.marketplace_manager.color_secondary == null
                ? "#fd1d18"
                : response.data.marketplace_manager.color_secondary,
          });
        } else {
          commit("SET_COLOR_THEME", {
            colorPrimary: "#001730",
            colorSecondary: "#fd1d18",
          });
        }
        // Tipo de conta (1 = Admin | 2 = Marketplace | 4 = Representante | 5 = Estabelecimento Comercial)
        commit("SET_USER", response.data);
        return response.data;
      }
    })
    .catch((e) => {

      console.log(e);
      // Process failure, delete the token
      dispatch("setToken", "");
      //
      return Promise.reject(new Error("FAIL_IN_LOAD_USER")); // keep promise chain
    });

export const AcceptConvite = ({ dispatch, commit }, payload) => {
  try {
    let promise = new Promise((resolve, reject) => {
      services
        .AcceptInvite(payload)
        .then((response) => {
          commit("SET_TOKEN", response.meta.token);
          // commit('SET_USER', response.data)
          dispatch("loadUser")
            .then((resp) => {
              return resolve(resp);
            })
            .catch((err) => {});
          resolve(response.data);
        })
        .catch((error) => {
          // reject(error)
          reject(getError(error));
        });
    });
    return promise;
  } catch (err) {
    console.log(err);
  }
};

export const setDisableSurvey = ({ commit }) => {
  commit("SET_SURVEY", false);
};
